import { render, staticRenderFns } from "./RedefinirSenhaUser.vue?vue&type=template&id=663adac6&scoped=true&"
import script from "./RedefinirSenhaUser.vue?vue&type=script&lang=js&"
export * from "./RedefinirSenhaUser.vue?vue&type=script&lang=js&"
import style0 from "./RedefinirSenhaUser.vue?vue&type=style&index=0&id=663adac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663adac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VApp,VBtn,VCol,VContainer,VContent,VRow,VSnackbar,VSpacer,VTextField})
